import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5445_18767)">
      <path
        d="M11.9999 7.75819C14.3668 7.75819 16.2857 9.65744 16.2857 12.0001C16.2857 14.3427 14.3668 16.2419 11.9999 16.2419C9.63321 16.2419 7.71428 14.3427 7.71428 12.0001C7.71428 9.65744 9.63321 7.75819 11.9999 7.75819ZM11.9999 0.122803C10.3832 0.122803 8.81142 0.437765 7.32643 1.05921C5.89607 1.65731 4.61357 2.5131 3.51429 3.60115C2.41499 4.68919 1.55035 5.95856 0.946072 7.37429C0.318214 8.84308 0 10.3999 0 12.0001C0 13.6004 0.318214 15.156 0.946072 16.6258C1.55035 18.0415 2.41499 19.3109 3.51429 20.399C4.61357 21.487 5.89607 22.3428 7.32643 22.9409C8.81035 23.5624 10.3832 23.8773 11.9999 23.8773C13.6167 23.8773 15.1886 23.5624 16.6735 22.9409C18.1039 22.3428 19.3864 21.487 20.4857 20.399C21.585 19.3109 22.4497 18.0415 23.0539 16.6258C23.6818 15.1571 24 13.6004 24 12.0001C24 10.3999 23.6818 8.84409 23.0539 7.37429C22.4497 5.95856 21.585 4.68919 20.4857 3.60115C19.3864 2.5131 18.1039 1.65731 16.6735 1.05921C15.1897 0.437765 13.6167 0.122803 11.9999 0.122803Z"
        fill="#B7F7B0"
      />
      <path
        d="M12.0002 7.75822C14.3669 7.75822 16.2858 9.65748 16.2858 12.0001C16.2858 14.3427 14.3669 16.2419 12.0002 16.2419C9.63332 16.2419 7.71439 14.3427 7.71439 12.0001C7.71439 9.65748 9.63332 7.75822 12.0002 7.75822ZM12.0002 2.66797C6.80154 2.66797 2.57153 6.8547 2.57153 12.0001C2.57153 17.1455 6.80154 21.3323 12.0002 21.3323C17.1987 21.3323 21.4287 17.1455 21.4287 12.0001C21.4287 6.8547 17.1987 2.66797 12.0002 2.66797Z"
        fill="#07DC10"
      />
      <path
        d="M11.9999 7.75814C14.3667 7.75814 16.2857 9.6574 16.2857 12.0001C16.2857 14.3426 14.3667 16.2418 11.9999 16.2418C9.63318 16.2418 7.71425 14.3426 7.71425 12.0001C7.71425 9.6574 9.63318 7.75814 11.9999 7.75814ZM11.9999 5.21301C8.21889 5.21301 5.14282 8.25761 5.14282 12.0001C5.14282 15.7424 8.21889 18.787 11.9999 18.787C15.7811 18.787 18.8571 15.7424 18.8571 12.0001C18.8571 8.25761 15.7811 5.21301 11.9999 5.21301Z"
        fill="#0C9B00"
      />
      <path
        d="M12 7.75818C14.3668 7.75818 16.2858 9.65743 16.2858 12.0001C16.2858 14.3427 14.3668 16.2419 12 16.2419C9.63327 16.2419 7.71436 14.3427 7.71436 12.0001C7.71436 9.65743 9.63327 7.75818 12 7.75818Z"
        fill="#EAEAEA"
      />
    </g>
    <defs>
      <clipPath id="clip0_5445_18767">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
